/**
 * Created by igor.kulishov on 8/30/2016.
 */
(function () {

    'use strict';

    angular
        .module('app.search')
        .factory('CacheSearchParams', [function () {
            var lastSearchParams = {
                location: '/loc/home/lang/en/search-result',
                params: '',
                searchCallbackUrl: '',
                maxModelsFound: ''
            };
            var srpCallback = {
                searchCallbackUrl :''
            };
            return {
                // 'Back to Search Results' link on VDP page
                storeLastSearchParams: function(location, params, searchCallbackUrl, updateStParam, maxModelsFound) {

                    if (location && params) {
                        lastSearchParams.location = location;
                        lastSearchParams.params = params;
                    }

                    // to obtain callback url from directive (after click on selected vehicle on srp page)
                    if (searchCallbackUrl) {
                        lastSearchParams.searchCallbackUrl = searchCallbackUrl
                    }

                    // update st parameter from service when st parameter got changed
                    if (parseInt(updateStParam) === 0 || parseInt(updateStParam) > 0) {
                        lastSearchParams.params.st = updateStParam;
                    }

                    if (maxModelsFound) {
                        lastSearchParams.maxModelsFound = maxModelsFound;
                    }

                    return lastSearchParams;
                }

            };
        }]);
})();


// WEBPACK FOOTER //
// ./app/search/components/service/CacheSearchParamsService.js